"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedLocalizationsPerSpace = void 0;
const language_code_model_1 = require("./language-code.model");
const language_code_model_2 = require("./language-code.model");
const space_model_1 = require("./space.model");
const nonDefaultSpaceLanguages = [
    ...language_code_model_2.cartoonsAdditionalLanguageCodes,
    ...language_code_model_1.rbtvAdditionalLanguageCodes,
    ...language_code_model_1.redbullComAdditionalLanguageCodes,
];
const defaultSpaceLanguages = language_code_model_2.supportedLanguageCodes.filter((code) => !nonDefaultSpaceLanguages.includes(code));
const cartoonsExcludedLanguages = ['en-SE'];
const brandBuildingEventsAdditionalLanguages = [
    'ka-GE',
    'he-IL',
    'is-IS',
];
const specialLanguageRestrictionsPerSpace = {
    'brand-building-events': [...brandBuildingEventsAdditionalLanguages, ...defaultSpaceLanguages],
    cartoons: [...language_code_model_2.cartoonsAdditionalLanguageCodes, ...defaultSpaceLanguages].filter((code) => !cartoonsExcludedLanguages.includes(code)),
    erc: ['en'],
    illume: ['en'],
    'pro-cycling': ['de', 'en'],
    rbtv: [...language_code_model_1.rbtvAdditionalLanguageCodes, ...defaultSpaceLanguages],
    'redbull-advancedtechnologies': ['en'],
    'redbull-f1academy': ['en'],
    'redbull-simracing': ['en'],
    redbull_com: [...language_code_model_1.redbullComAdditionalLanguageCodes, ...defaultSpaceLanguages],
    redbulletin: [
        'de',
        'de-AT',
        'de-CH',
        'de-DE',
        'en',
        'en-GB',
        'en-US',
        'fr',
        'fr-CH',
        'fr-FR',
    ],
    speedweek: ['de', 'en'],
    wrc: ['en'],
    wrcpromoter: ['en'],
    xalps: ['en'],
};
exports.allowedLocalizationsPerSpace = {
    ...space_model_1.supportedSpaces.reduce((acc, space) => ({
        ...acc,
        [space]: specialLanguageRestrictionsPerSpace[space] || defaultSpaceLanguages,
    }), {}),
};
//# sourceMappingURL=data:application/json;base64,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